/**
 * Utility functions for authentication checks and token management
 */

export interface StoredUser {
  sub?: string;
  email?: string;
  name?: string;
  nickname?: string;
  picture?: string;
  updated_at?: string;
  [key: string]: any;
}

export interface AuthState {
  isLoggedIn: boolean;
  token: string | null;
  user: StoredUser | null;
  tokenTimestamp: number | null;
}

/**
 * Check if user is logged in by validating stored token and user data
 */
export const isUserLoggedIn = (): boolean => {
  const token = localStorage.getItem('authToken');
  const user = localStorage.getItem('authUser');
  
  return !!(token && user);
};

/**
 * Get the complete auth state from localStorage
 */
export const getAuthState = (): AuthState => {
  const token = localStorage.getItem('authToken');
  const userStr = localStorage.getItem('authUser');
  const tokenTimestamp = localStorage.getItem('authTokenTimestamp');
  
  let user: StoredUser | null = null;
  if (userStr) {
    try {
      user = JSON.parse(userStr);
    } catch (error) {
      console.error('Failed to parse stored user data:', error);
    }
  }
  
  return {
    isLoggedIn: !!(token && user),
    token: token || null,
    user: user,
    tokenTimestamp: tokenTimestamp ? parseInt(tokenTimestamp) : null,
  };
};

/**
 * Get the stored auth token
 */
export const getStoredToken = (): string | null => {
  return localStorage.getItem('authToken');
};

/**
 * Get the stored user details
 */
export const getStoredUser = (): StoredUser | null => {
  const userStr = localStorage.getItem('authUser');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Failed to parse stored user data:', error);
    return null;
  }
};

/**
 * Clear all auth data from localStorage
 */
export const clearAuthData = (): void => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
  localStorage.removeItem('authTokenTimestamp');
  sessionStorage.removeItem('just_logged_in');
};

/**
 * Check if the stored token is still valid (basic check - doesn't validate signature)
 * In production, you should validate token expiration on the server
 */
export const isTokenValid = (): boolean => {
  const token = localStorage.getItem('authToken');
  const tokenTimestamp = localStorage.getItem('authTokenTimestamp');
  
  if (!token || !tokenTimestamp) {
    return false;
  }
  
  // Check if token exists and user data exists
  const user = localStorage.getItem('authUser');
  return !!(token && user);
};


export const getEnvVar = (key: string): string => {
  const value = process.env[key];
  // if (!value) {
  //   throw new Error(`Missing required environment variable: ${key}`);
  // }
  // return value
  return value ? value : '';
}

//Check OrgId from localStorage
export const getOrgId = (): string | null => {
  const authUser = localStorage.getItem("authUser");

  if (authUser) {
    const parsedUser = JSON.parse(authUser);
    const orgId = parsedUser.org_id;
    return orgId;
    
  } 
  return null
};